export const PRODUCT_CATEGORY_DEFINITIONS = [
  {
    value: 'Business Product',
    description: 'The user-facing offering itself.',
  },
  {
    value: 'Service (Domain Service)',
    description:
      'A runtime dependency of a product. Provides direct business functionality. A product can depend on many services, and services can depend on each other.',
  },
  {
    value: 'Service (Domain Microservice)',
    description:
      'A runtime dependency of a product. Exposes a domain-specific concept or business logic, smaller than a Domain Service. A product can depend on many services, and services can depend on each other.',
  },
  {
    value: 'Service (Platform Service)',
    description:
      'A runtime dependency of a product. Generalized functionality not tied to any one domain, at a broader scale. A product can depend on many services, and services can depend on each other.',
  },
  {
    value: 'Service (Platform Microservice)',
    description:
      'A runtime dependency of a product. Generalized functionality not tied to any one domain, smaller and usable regardless of the domain content it handles. A product can depend on many services, and services can depend on each other.',
  },
  {
    value: 'Internal Tool',
    description:
      'An application used directly by employees or engineering teams, rather than a service consumed by other systems at runtime.',
  },
] as const;

export type ProductCategory = (typeof PRODUCT_CATEGORY_DEFINITIONS)[number]['value'];

export const PRODUCT_CATEGORIES: readonly ProductCategory[] =
  PRODUCT_CATEGORY_DEFINITIONS.map(definition => definition.value);

/** Previous category name. Still counted as internal until catalog data is refreshed. */
export const LEGACY_INTERNAL_PRODUCT_CATEGORY = 'Internal Product';

export function isInternalProductCategory(category: string): boolean {
  const value = category.trim();
  return value === 'Internal Tool' || value === LEGACY_INTERNAL_PRODUCT_CATEGORY;
}

/** Domain, platform, service, and microservice names are one Service group. */
export function isServiceProductCategory(category: string): boolean {
  return category.trim().toLowerCase().startsWith('service');
}

export function isBusinessProductCategory(category: string): boolean {
  return category.trim().toLowerCase() === 'business product';
}
